export default __webpack_public_path__ + "static/gatsby_github_settings_developer_settings-f3dd08327aea89aef4cd5c91d56891ae.png";